import { Placeholder, PlayButton } from "components/molecules/player/styled";
import React, { memo, useState } from "react";

const ProductPreview: React.FC<ProductItemProps> = memo(
  ({ src, name, shouldLazy, isVideo }) => {
    const [_name, setName] = useState("");
    setTimeout(() => {
      setName(name);
    }, 1200);
    return (
      <div className="m-productcarousel_item first">
        {isVideo && (
          <Placeholder className="m-player-placeholder">
            <PlayButton className="m-player-playbtn" />
          </Placeholder>
        )}
        <img
          {...(shouldLazy
            ? { "data-src": src, className: "swiper-lazy" }
            : { src })}
          alt={_name}
        />
        {shouldLazy && <div className="swiper-lazy-preloader" />}
      </div>
    );
  },
);

export default ProductPreview;
